var ajax = require('sma.common/ajax');
var modals = require('sma.common/components/modals');
var formErrors = require('sma.common/formErrors.js')

let STRINGS = {
	'delete': gettext('Delete'),
	'edit': gettext('Edit'),
	'notes': gettext('Notes'),
	'save': gettext('Save changes'),
	'cancel': gettext('Cancel'),
	'private_tooltip': gettext('This note can only be seen by admins'),
	'edited': gettext('(edited)'),
	'private_note': gettext('Private note (admin only)'),
	'no_notes': gettext('There are currently no notes on this application')
}

let noteListPartial = require('sma.admin/partials/notes/note_list.mustache');
let noteEditPartial = require('sma.admin/partials/notes/note_edit.mustache');
let notePartial = require('sma.admin/partials/notes/note.mustache');

var Note = Backbone.View.extend({
	initialize: function(config) {
		this.setElement(config.element[0]);
		this.data = config.data;
		this.is_reviewer = this.data.is_reviewer = config.is_reviewer;
		this.list = config.list;
		this.render();
		this.noteElement = $(this.el).find("#note-")
	},

	events: {
		'click .sma-js-edit-note': 'editNote',
		'click .sma-js-cancel-edit': 'cancelEdit',
		'submit .sma-js-note-edit-form': 'submitForm',
	},

	render: function() {
		var context = this.data;
		const template = '<div class="tooltip application-notes-tooltip" role="tooltip"><div class="arrow"></div><div class="tooltip-inner"></div></div>';
		context['strings'] = STRINGS;
		$(this.el).html(notePartial(context));
		$('.sma-js-tooltip').tooltip({ template });
	},

	cancelEdit: function(e) {
		e.preventDefault();
		this.render();
	},

	editNote: function(e) {
		e.preventDefault();
		var token = $("input[name=csrfmiddlewaretoken]").val();
		var target = $(e.currentTarget);
		var note_id = target.attr('data-note-id');
		var parent = $(e.currentTarget).parents('#note-' + note_id);
		var href = target.attr('href');

		var options = {
			url: href,
			callback: (data) => {
				var context = {
					'strings': STRINGS,
					'token': token,
					'content': data.content,
					'edit_url': href,
					'private': data.private,
					'is_admin': !this.is_reviewer
				}
				parent.html(noteEditPartial(context));
			}
		}
		ajax.get(options);
	},

	submitForm: function(e) {
		e.preventDefault();
		var form = $(e.currentTarget);
		var target = $(form.attr('data-target'));
		var data = new FormData(form[0]);

		var options = {
			type: form.attr('method'),
			url: form.attr('action'),
			data: data,
			processData: false,
			contentType: false,
			alwaysCallback: true,
			callback: (data) => {
				if (!data.errors) {
					formErrors.removeErrors(form);
					this.data = data.note;
					this.render();
				} else {
					formErrors.removeErrors(form);
					formErrors.addErrors(form, data.errors);
				}
			}
		}
		ajax.post(options);
	},
})

var ApplicationNotes = Backbone.View.extend({
	initialize: function(config) {
		this.data = [];
		this.is_reviewer = 'is_reviewer' in config ? config.is_reviewer : 0;
		this.setElement(config.element[0]);
		this.noteList = $(".sma-js-application-note-container");
		this.submission = config.submission
		this.getSubmissionNotes();
		var saveButton = $(this.el).find('.sma-js-add-note');
		this.toggleSaveButton(saveButton, '')
	},

	events: {
		'submit .sma-js-note-form': 'submitForm',
		'click .sma-js-delete-note': 'deleteNote',
		'click #id_private': 'togglePrivate',
		'keyup #id_content': 'updateSave',
	},

	getSubmissionNotes: function() {
		var options = {
			url: reverse('application-notes' , {
				submission_id: this.submission
			}),
			type: 'GET',
			data: {
				is_reviewer: this.is_reviewer,
			},
			callback: (data) => {
				data['strings'] = STRINGS;
				this.data = data;
				this.renderNoteList();
				this.renderNotes();
			}
		}
		ajax.get(options)
	},

	renderNoteList: function() {
		this.noteList.html(noteListPartial(this.data))
	},

	updateSave: function(e) {
		var target = $(e.currentTarget);
		var form = target.parents('form');
		var saveButton = form.find('button[type="submit"]');
		var value = target.val();

		this.toggleSaveButton(saveButton, value);
	},

	toggleSaveButton: function(button, val) {
		var value = val.replace(/ /g,'').trim();
		if (value == '') {
			button.attr('disabled', 'disabled');
		} else {
			button.attr('disabled', false);
		}
	},

	renderNotes: function() {
		var that = this;
		for (var i in this.data.notes) {
			var data = this.data.notes[i];
			var note_el = this.noteList.find('#note-' + data.id);
			var note = new Note({
				element: note_el,
				list: that.noteList,
				data: data,
				is_reviewer: that.is_reviewer,
			})
		}
		this.noteList.change()
	},

	togglePrivate: function(e) {
		var target = $(e.currentTarget);
		var checked = target.is(':checked');
		var email_reviewers = $("#id_email_reviewers");

		if (checked) {
			email_reviewers.attr('disabled', true);
			email_reviewers.prop('checked', false);
		} else {
			email_reviewers.attr('disabled', false);
		}
	},

	submitForm: function(e) {
		e.preventDefault();
		var form = $(e.currentTarget);
		var target = $(form.attr('data-target'));
		var data = new FormData(form[0]);

		var options = {
			type: form.attr('method'),
			url: form.attr('action'),
			data: data,
			processData: false,
			contentType: false,
			alwaysCallback: true,
			callback: (data) => {
				if (!data.errors) {
					form[0].reset();
					$("#id_email_reviewers").attr('disabled', false);
					this.getSubmissionNotes();
				} else {
					formErrors.removeErrors(form)
					formErrors.addErrors(form, data.errors)					
				}
			}
		}
		ajax.post(options);
	},

	deleteNote: function(e) {
		e.preventDefault()

		let options = {
			url: $(e.currentTarget).attr('href'),
			callback: () => {
				this.getSubmissionNotes();
			}
		}
		
		new modals.CheckboxModal(
			gettext('Delete Note'),
			gettext('Deleting this application note will permanently delete this data and cannot be undone.'),
			gettext('Yes, I understand.'),
			(modal) => {
				ajax.post(options);
			},
			{
				contingent: true,
				isDelete: true
			}
		)
	},
})

module.exports = ApplicationNotes;
